import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ApiToken, Response} from '../models/models';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiTokenService {

  constructor(private httpClient: HttpClient) { }

  getApiTokens(): Observable<Response<ApiToken[]>> {
    return this.httpClient.get<Response<ApiToken[]>>(environment.apiPath + 'ApiToken');
  }

  insertApiToken(apiToken: ApiToken): Observable<Response<ApiToken>> {
    return this.httpClient.post<Response<ApiToken>>(environment.apiPath + 'ApiToken/', apiToken);
  }

  updateApiToken(id: number, apiToken: ApiToken): Observable<Response<ApiToken>> {
    return this.httpClient.put<Response<ApiToken>>(environment.apiPath + 'ApiToken/' + id, apiToken);
  }

  deleteApiToken(id: number) {
    return this.httpClient.delete<Response<boolean>>(environment.apiPath + 'ApiToken/' + id);
  }
}
